import { PreloaderService } from './../../../common/services/preloader/preloader.service';
import { FETCH_ALL_DESTINATION_SUCCEEDED } from './../../destination/destination.action';
import { ApiService } from './../../../api/api.service';
import { API_CALL_ERROR } from './../../../store/action';
import { call, put, takeEvery, takeLatest, fork } from 'redux-saga/effects';
import {
  FETCH_LOCATIONS_REQUESTED,
  FETCH_LOCATIONS_SUCCEEDED,
  FETCH_LOCATION_BY_DESTINATION_ID_REQUESTED,
  FETCH_LOCATION_BY_DESTINATION_ID_SUCCEEDED,
  DELETE_LOCATION_REQUESTED,
  DELETE_LOCATION_SUCCEEDED,
  MAP_DESTINATION_TO_LOCATION,
  LOCATION_COMPONENT_UPDATE_DESTINATION_FILTER
} from './list.action';
import * as _ from 'lodash';
import { ReflectiveInjector, Injector } from '@angular/core';
import { AppInjector } from '../../../app-injector';
import { FETCH_ALL_DESTINATION_REQUESTED } from '../../destination/destination.action';
import { ActivatedRoute, Router } from '@angular/router';

function* fetchLocations(action) {
  try {
    const api = AppInjector.get(ApiService);
    let results = yield api.location.get(action.data).toPromise();
    yield put({
      type: FETCH_LOCATIONS_SUCCEEDED,
      data: results.items,
      pagination: results.pagination
    });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchLocationRequested() {
  yield takeEvery(FETCH_LOCATIONS_REQUESTED, fetchLocations);
}

function* fetchLocationByDestinationId(action) {
  try {
    const api = AppInjector.get(ApiService);
    let results = yield api.location.getLocationByDestinationId(action.data).toPromise();
    yield put({
      type: FETCH_LOCATION_BY_DESTINATION_ID_SUCCEEDED,
      data: results
    });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchLocationByDestinationIdRequested() {
  yield takeEvery(FETCH_LOCATION_BY_DESTINATION_ID_REQUESTED, fetchLocationByDestinationId);
}

function* deleteLocation(action) {
  const api = AppInjector.get(ApiService);
  try {
    AppInjector.get(PreloaderService).show();

    let result = yield api.location.delete(action.data).toPromise();

    if (!_.isUndefined(action.com)) {
      AppInjector.get(Router).navigate(['location']);
    } else {
      yield put({ type: DELETE_LOCATION_SUCCEEDED, data: result });
      yield put({ type: FETCH_LOCATIONS_REQUESTED });
    }

    AppInjector.get(PreloaderService).hide();
  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDeleteLocationRequest() {
  yield takeEvery(DELETE_LOCATION_REQUESTED, deleteLocation);
}

function* getDestinations(action) {
  yield put({ type: FETCH_ALL_DESTINATION_REQUESTED, com: 'LOCATION_LIST_COMPONENT' });
}

function* watchFetchLocationsSuccess() {
  yield takeEvery(FETCH_LOCATIONS_SUCCEEDED, getDestinations);
}

function* mapDestinationToLocation(action) {
  if (action.com === 'LOCATION_LIST_COMPONENT') {
    yield put({ type: MAP_DESTINATION_TO_LOCATION, data: action.data });
  }
}

function* watchFetchDestinationSuccess() {
  yield takeEvery(FETCH_ALL_DESTINATION_SUCCEEDED, mapDestinationToLocation);
}

function updateDestinationFilterr(action) {
  let activeRouter = AppInjector.get(ActivatedRoute);
  let router = AppInjector.get(Router);
  let params = activeRouter.snapshot.params;
  let queryParams = _.assign({}, activeRouter.snapshot.queryParams, { page: 1 });
  let url = activeRouter.snapshot.url;
  let constraints = {};
  if (!_.isUndefined(queryParams.constraints)) {
    constraints = _.assign(constraints, JSON.parse(queryParams.constraints));
  }
  if (action.field === 'destination') {
    if (!_.isUndefined(action.data)) {
      constraints = _.assign(constraints, { destination_id: action.data.getId() });
    } else {
      delete constraints['destination_id'];
    }
  }
  queryParams = _.assign(queryParams, { constraints: JSON.stringify(constraints) });
  router.navigate([url], { queryParams: queryParams });
}

function* watchUpdateDestinationFilter() {
  yield takeEvery(LOCATION_COMPONENT_UPDATE_DESTINATION_FILTER, updateDestinationFilterr);
}

export default [
  watchFetchLocationRequested,
  watchFetchLocationByDestinationIdRequested,
  watchDeleteLocationRequest,
  watchFetchLocationsSuccess,
  watchFetchDestinationSuccess,
  watchUpdateDestinationFilter
];
